import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

type PriceComponentProps = {
    item: OrderItemModel;
};

const PriceComponent = ({ item }: PriceComponentProps) => {
    const { t } = useGranite();

    return (
        <>
            {item.showStrippedPrice && (
                <s className="font-weight-light d-block">
                    {formatPrice(item.strikethroughPrice!)}
                </s>
            )}
            <div className="h4 font-weight-bold mb-0">
                {formatPrice(
                    item.unitPrice,
                    item.free ? { freeLabel: true, t: t } : undefined
                )}
            </div>
        </>
    );
};

export { PriceComponent };
